import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
import { metaTag } from "../Library/commomLib";
const CheckboxComponent = React.lazy(() => import("../Components/RootComponents/CheckboxComponent"));
const CheckboxPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <CheckboxComponent />
      </Suspense>
    </Fragment>
  );
};

export default CheckboxPage;
